let mainPath = "/alterations";
let viewFolder = "Alteration";

module.exports = [
    {
        path: mainPath,
        name: 'alterations',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/Index.vue'),
        // beforeEnter: (to, from, next) => {
        //   if (!localStorage.getItem('userId')) next({ name: 'Home' })
        //   else next()
        // }
    }
]